import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, withModifiers as _withModifiers, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "flex flex-col w-full lg:my-6 max-w-[666px]" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "mb-4" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "input-label" }, [
    /*#__PURE__*/_createTextVNode(" Prosimy o dodanie karty ciąży oraz opcjonalnie dodatkowych dokumentów."),
    /*#__PURE__*/_createElementVNode("span", { class: "text-error" }, "*")
  ])
], -1)
const _hoisted_3 = { class: "flex items-start lg:items-center justify-start mt-6 w-full" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "ml-5" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-[12px] m-0 md:text-[15px] font-normal leading-[15px] lg:leading-6 mt-1 text-placeholder" }, [
    /*#__PURE__*/_createTextVNode(" Dodaj do 5 plików. "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" Akceptowane formaty: pdf, jpg, png ")
  ])
], -1)
const _hoisted_5 = { class: "flex items-center justify-start" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "w-[56px] h-[56px] rounded-sm bg-light flex items-center justify-center" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "22",
    height: "23",
    viewBox: "0 0 22 23",
    fill: "none"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M20.4383 10.6622L11.2483 19.8522C10.1225 20.9781 8.59552 21.6106 7.00334 21.6106C5.41115 21.6106 3.88418 20.9781 2.75834 19.8522C1.63249 18.7264 1 17.1994 1 15.6072C1 14.015 1.63249 12.4881 2.75834 11.3622L11.9483 2.17222C12.6989 1.42166 13.7169 1 14.7783 1C15.8398 1 16.8578 1.42166 17.6083 2.17222C18.3589 2.92279 18.7806 3.94077 18.7806 5.00222C18.7806 6.06368 18.3589 7.08166 17.6083 7.83222L8.40834 17.0222C8.03306 17.3975 7.52406 17.6083 6.99334 17.6083C6.46261 17.6083 5.95362 17.3975 5.57834 17.0222C5.20306 16.6469 4.99222 16.138 4.99222 15.6072C4.99222 15.0765 5.20306 14.5675 5.57834 14.1922L14.0683 5.71222",
      stroke: "#939393",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    })
  ])
], -1)
const _hoisted_7 = { class: "ml-2 Text" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "error-message" }

import { watch } from 'vue';
import { useFieldArray, useField, ErrorMessage } from 'vee-validate';
import Dropzone from '../../ui/Dropzone.vue';
import { useOnDrop } from '../../../hooks/useOnDrop';


export default {
  __name: 'UploadPrenatalDocumentation',
  setup(__props) {

const { fields, push, remove } = useFieldArray('uploadedFile');

useField('uploadedFile');

const { onDrop, onSelectFile } = useOnDrop(push, fields);

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createVNode(Dropzone, {
            onChange: _unref(onSelectFile),
            onDrop: _withModifiers(_unref(onDrop), ["prevent"])
          }, null, 8, ["onChange", "onDrop"]),
          _hoisted_4
        ])
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(fields), (field, id) => {
        return (_openBlock(), _createElementBlock("div", {
          key: field.key,
          class: "flex items-center justify-between my-4"
        }, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("p", _hoisted_7, _toDisplayString(field.value.name), 1)
          ]),
          _createElementVNode("button", {
            onClick: $event => (_unref(remove)(id)),
            type: "button",
            class: "Button min-w-[80px] Button--no-style text-accent underline"
          }, " Usuń plik ", 8, _hoisted_8)
        ]))
      }), 128))
    ]),
    _createVNode(_unref(ErrorMessage), { name: "uploadedFile" }, {
      default: _withCtx(({ message }) => [
        _createElementVNode("p", _hoisted_9, _toDisplayString(message), 1)
      ]),
      _: 1
    })
  ], 64))
}
}

}